import { gql } from '@apollo/client'
import { client } from '../client';


const SUBSCRIBE_TO_TRANSPORTATION_PUSH_NOTIFICATION_MUTATION = gql`
  mutation SubscribeToTransportationPushNotification($qtirLanguageId: Int!, $transportationId: Int!, $eventType: String!, $subscription: JSON!) {
    subscribeToTransportationPushNotification(qtirLanguageId: $qtirLanguageId, transportationId: $transportationId, eventType: $eventType, subscription: $subscription)
  }
`

interface SubscribeToTransportationPushNotificationData {
  subscribeToTransportationPushNotification: boolean
}

interface SubscribeToTransportationPushNotificationVars {
  transportationId: number,
  qtirLanguageId: number,
  subscription: any,
  eventType: 'CALL_TRANSPORTATION',
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const subscribeToTransportationPushNotification = (args: SubscribeToTransportationPushNotificationVars) => {
  return client.mutate<SubscribeToTransportationPushNotificationData, SubscribeToTransportationPushNotificationVars>({
    mutation: SUBSCRIBE_TO_TRANSPORTATION_PUSH_NOTIFICATION_MUTATION,
    variables: args,
  })
}
